import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {
  MODALS,
  fetchAllocations,
  fetchAllocationStatistics,
  initialFilters
} from 'ducks/allocations';
import {withFilters, FILTERS} from 'components/withFilters';

import {CreateRoomForm, Buttons} from './components';

import './styles.css';

class CreateRoomModal extends React.Component<any> {
  triggerSubmit = () => this.props.submit('createRoom');

  getExtraActions = () => {
    const {locationRef} = this.props.data;
    return [
      () => this.props.clearFilters(),
      () => fetchAllocations({locationRef}),
      () => fetchAllocationStatistics({locationRef}),
      ...this.props.closeModalExtraActions
    ];
  };

  render() {
    const {closeModal, form: {submitting}, data: {locationRef}} = this.props;
    return (
      <Modal
        modalOverlayClassName="CreateRoomModalOverlay"
        className="CreateRoomModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={closeModal}>
        <Modal.Header heading="Create Room" />
        <Modal.Body>
          <CreateRoomForm
            storeDataExtraActions={this.props.storeDataExtraActions}
            getExtraActions={this.getExtraActions}
            locationRef={locationRef}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            submitting={submitting}
            closeModal={closeModal}
            triggerSubmit={this.triggerSubmit}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: {
      submitting: isSubmitting('createRoom')(state)
    }
  };
};

const mapDispatchToProps = {
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withFilters(
    withModal(MODALS.CREATE_ROOM)(CreateRoomModal),
    FILTERS.ALLOCATIONS_CALENDAR,
    {initialFilters, clearFiltersOnUnmount: false}
  )
);
